"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPermissionNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.512 14.812h.5v-.45l-.447-.047-.053.497zm-4.26-4.303l.498-.049-.044-.451h-.454v.5zm4.313 3.806a4.302 4.302 0 01-3.816-3.854l-.995.096a5.302 5.302 0 004.705 4.752l.106-.994zM9.7 11.009h7.552v-1H9.7v1zm-.7.7a.7.7 0 01.7-.7v-1a1.7 1.7 0 00-1.7 1.7h1zM9 22.3V11.71H8V22.3h1zm.7.7a.7.7 0 01-.7-.7H8A1.7 1.7 0 009.7 24v-1zm10.612 0H9.7v1h10.612v-1zm.7-.7a.7.7 0 01-.7.7v1a1.7 1.7 0 001.7-1.7h-1zm0-7.488V22.3h1v-7.488h-1z",
    fill: props.color || "#133251"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.9,
    cy: 9.1,
    r: 3.6,
    stroke: props.color || "#133251"
  }));
}

var _default = SvgPermissionNotification;
exports["default"] = _default;